export const taxonomyNodeKinds = [
  'domain',
  'activity',
  'country',
  'league',
  'club',
  'facet',
  'option',
  'session',
] as const;
export type TaxonomyNodeKind = (typeof taxonomyNodeKinds)[number];

export const taxonomyNodeStatuses = ['active', 'archived'] as const;
export type TaxonomyNodeStatus = (typeof taxonomyNodeStatuses)[number];

export const taxonomyNodeSources = ['authored', 'feed'] as const;
export type TaxonomyNodeSource = (typeof taxonomyNodeSources)[number];

export const taxonomyPromptTypes = ['selection', 'text', 'consent'] as const;
export type TaxonomyPromptType = (typeof taxonomyPromptTypes)[number];

// Trilingual authoring shape shared by `labels` and `prompt.title`: a keyed
// {en,nl,fr} object on the wire, NOT a TranslationEntity[] array. The BE
// entity/DB already store this shape verbatim, so mirror it here rather than
// reusing TranslationEntity[] (which would force a conversion on every write).
export interface TaxonomyLabels {
  en: string;
  nl: string;
  fr: string;
}

// The AUTHORING shape for a node's fan-facing question (stored as nullable
// jsonb server-side). Distinct from the fan-response `title` on
// PreferencePrompt (single resolved locale) — see preferences.entity.ts.
export interface TaxonomyPromptEntity {
  type: TaxonomyPromptType;
  title: TaxonomyLabels;
  optionsSource: 'children';
}

export interface TaxonomyNodeEntity {
  id: string;
  parentId: string | null;
  kind: TaxonomyNodeKind;
  selectable: boolean;
  sortOrder: number;
  labels: TaxonomyLabels;
  status: TaxonomyNodeStatus;
  // Response-only, informational — never sent in a request body.
  source: TaxonomyNodeSource;
  prompt?: TaxonomyPromptEntity | null;
}

export interface TaxonomyTreeResponse {
  nodes: TaxonomyNodeEntity[];
}
